import { render } from "./ApplyAvatarPosterTemplate.vue?vue&type=template&id=d279f720&scoped=true&ts=true"
import script from "./ApplyAvatarPosterTemplate.vue?vue&type=script&lang=ts"
export * from "./ApplyAvatarPosterTemplate.vue?vue&type=script&lang=ts"

import "./ApplyAvatarPosterTemplate.vue?vue&type=style&index=0&id=d279f720&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d279f720"]])

export default __exports__